import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SHARED_ENVIRONMENT } from '@cp/shared/environment/environment.token';
import { Environment } from '@cp/shared/environment/environment.interface';

export interface ErrorIncorrectStatusModalData {
  title: string;
}

@Component({
  selector: 'ui-error-incorrect-status-modal',
  templateUrl: './error-incorrect-status-modal.component.html',
  styleUrls: ['./error-incorrect-status-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ErrorIncorrectStatusModalComponent implements OnInit {
  public title = '';
  public dashboardUrl = this._environment.globalDashboardUrl;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ErrorIncorrectStatusModalData,
    private _dialogRef: MatDialogRef<ErrorIncorrectStatusModalComponent>,
    @Inject(SHARED_ENVIRONMENT) private _environment: Environment,
  ) {}

  public ngOnInit(): void {
    this.title = this.data?.title ?? 'Something went wrong!';
  }

  public closeModal(event: Event): void {
    event.preventDefault();

    this._dialogRef.close();
  }
}
